export const Constants = {
  DEFAULT_USER_NAME: "AstroLive 🔥",
  LIVESTREAM_BASE_URL: "https://astrolive.app/live/",
  AUDIOSTREAM_BASE_URL: "https://astrolive.app/room/",
  PLAY_STORE: "https://astroliveapp.page.link/downloadnow",
  APPLE_STORE: "https://astroliveapp.page.link/downloadnow",
  LIVESTREAM_ROOM_BASE_URL: "https://dev-webview.astrolive.app/",
  INPUT_LABEL_17:
    "Where you get to know about AstroLive live streaming feature?",
};
